import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Underline: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.54791 5.57143C9.54791 4.97969 9.06001 4.5 8.45817 4.5C7.85633 4.5 7.36843 4.97969 7.36843 5.57143V11.7321C7.36843 14.247 9.44198 16.2857 11.9998 16.2857C14.5577 16.2857 16.6312 14.247 16.6312 11.7321V5.57143C16.6312 4.97969 16.1434 4.5 15.5415 4.5C14.9397 4.5 14.4518 4.97969 14.4518 5.57143V11.7321C14.4518 13.0635 13.354 14.1429 11.9998 14.1429C10.6457 14.1429 9.54791 13.0635 9.54791 11.7321V5.57143ZM6.00625 17.3571C5.4044 17.3571 4.9165 17.8368 4.9165 18.4286C4.9165 19.0203 5.4044 19.5 6.00625 19.5H17.9934C18.5953 19.5 19.0832 19.0203 19.0832 18.4286C19.0832 17.8368 18.5953 17.3571 17.9934 17.3571H6.00625Z"
      fill="currentColor"
    />
  </svg>
);
